import api from './api';

export interface AdminExpenseCategoryConfig {
  id: number;
  code: string;
  display_name: string;
  is_active: boolean;
  sort_order: number;
  updated_at: string;
}

export interface AdminMerchantPattern {
  id: number;
  name: string;
  is_active: boolean;
  priority: number;
  match_type: 'CONTAINS' | 'STARTS_WITH' | 'ENDS_WITH' | 'REGEX' | 'FROM_EMAIL';
  match_value: string;
  merchant_canonical: string | null;
  category: string;
  created_at: string;
  updated_at: string;
}

export interface AdminEmailIngestionLog {
  id: number;
  status: string;
  sync_start: string;
  sync_end: string | null;
  emails_scanned: number;
  emails_processed: number;
  emails_failed: number;
  error_message: string | null;
  created_at: string;
}

export interface AdminClassificationReview {
  id: number;
  email_transaction: number;
  reviewed_by: number;
  is_correct: boolean;
  corrected_category: string | null;
  notes: string | null;
  created_at: string;
}

export const gmailExpensesAdminService = {
  // Categories
  async listCategories(): Promise<AdminExpenseCategoryConfig[]> {
    const res = await api.get('/gmail-expenses/admin/categories/');
    return res.data;
  },

  async seedDefaultCategories(): Promise<{ created: number }> {
    const res = await api.post('/gmail-expenses/admin/categories/seed_defaults/');
    return res.data;
  },

  async updateCategory(id: number, data: Partial<AdminExpenseCategoryConfig>): Promise<AdminExpenseCategoryConfig> {
    const res = await api.patch(`/gmail-expenses/admin/categories/${id}/`, data);
    return res.data;
  },

  // Merchant patterns
  async listMerchantPatterns(): Promise<AdminMerchantPattern[]> {
    const res = await api.get('/gmail-expenses/admin/merchant-patterns/');
    return res.data;
  },

  async createMerchantPattern(data: Partial<AdminMerchantPattern>): Promise<AdminMerchantPattern> {
    const res = await api.post('/gmail-expenses/admin/merchant-patterns/', data);
    return res.data;
  },

  async updateMerchantPattern(id: number, data: Partial<AdminMerchantPattern>): Promise<AdminMerchantPattern> {
    const res = await api.patch(`/gmail-expenses/admin/merchant-patterns/${id}/`, data);
    return res.data;
  },

  async deleteMerchantPattern(id: number): Promise<void> {
    await api.delete(`/gmail-expenses/admin/merchant-patterns/${id}/`);
  },

  // Classification reviews
  async listClassificationReviews(): Promise<AdminClassificationReview[]> {
    const res = await api.get('/gmail-expenses/admin/classification-reviews/');
    return res.data;
  },

  async createClassificationReview(data: {
    email_transaction: number;
    is_correct: boolean;
    corrected_category?: string | null;
    notes?: string | null;
  }): Promise<AdminClassificationReview> {
    const res = await api.post('/gmail-expenses/admin/classification-reviews/', data);
    return res.data;
  },

  // Ingestion logs
  async listIngestionLogs(): Promise<AdminEmailIngestionLog[]> {
    const res = await api.get('/gmail-expenses/admin/email-ingestion-logs/');
    return res.data;
  },
};

